import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import Navigation from "./components/Navigation";
import HomePage from "./pages/HomePage";
import ResourcesPage from "./pages/ResourcesPage";
import SecurityPage from "./pages/SecurityPage";
import CompanyPage from "./pages/CompanyPage";
import GuidesListPage from "./pages/GuidesListPage";
import GuidePage from "./pages/GuidePage";
import UseCasePage from "./pages/UseCasePage";
import ComparisonPage from "./pages/ComparisonPage";
import WebinarPage from "./pages/WebinarPage";
import LegalPage from "./pages/LegalPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";
import ExitIntentModal from "./components/ExitIntentModal";
import Intercom from "./components/Intercom";
import WebhookTracker from "./components/WebhookTracker";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ExitIntent() {
  const { pathname } = useLocation();
  if (pathname === '/webinar') return null;
  return <ExitIntentModal />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <main>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/guides" element={<GuidesListPage />} />
          <Route path="/guides/getting-started" element={<GuidePage />} />
          <Route path="/use-cases/accounts-payable-automation" element={<UseCasePage />} />
          <Route path="/comparisons/plouton-vs-traditional-rpa" element={<ComparisonPage />} />
          <Route path="/webinar" element={<WebinarPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/legal" element={<LegalPage />} />
        </Routes>
        </main>
        <Toaster position="top-center" richColors />
        <ExitIntent />
        <Intercom />
        <WebhookTracker />
      </BrowserRouter>
    </div>
  );
}

export default App;
